var types = {
	USER_GET: "USER_GET",

	/*Dashboard Action Types*/
	AUDITOR_STATS_GET: "AUDITOR_STATS_GET",
	AUDITOR_SCORE_GET: "AUDITOR_SCORE_GET",

	/*Profile Info Action Types*/
	PROFILE_INFO_GET: "PROFILE_INFO_GET",
	PROFILE_INFO_POST: "PROFILE_INFO_POST",

	/*Bank Info Action Types*/
	BANK_INFO_GET: "BANK_INFO_GET",
	BANK_INFO_POST: "BANK_INFO_POST",

	/*Additional Info Action Types*/
	ADDITIONAL_INFO_GET: "ADDITIONAL_INFO_GET",
	ADDITIONAL_INFO_POST: "ADDITIONAL_INFO_POST",

	/*Social Info Action Types*/
	SOCIAL_INFO_GET: "SOCIAL_INFO_GET",
	SOCIAL_INFO_POST: "SOCIAL_INFO_POST",

	AUDIT_GET: "AUDIT_GET",
	AUDIT_ID_GET: "AUDIT_ID_GET",

	TRAVEL_AUDIT_GET: "TRAVEL_AUDIT_GET",

	APPLICATION_GET: "APPLICATION_GET",

	AUDIT_APPLY_FORM_LOAD: "AUDIT_APPLY_FORM_LOAD",
	AUDIT_APPLY_FORM_SUB: "AUDIT_APPLY_FORM_SUB",

	AUDIT_CANCEL_FORM_LOAD: "AUDIT_CANCEL_FORM_LOAD",
	AUDIT_CANCEL_FORM_SUB: "AUDIT_CANCEL_FORM_SUB",

	AUDIT_STORE_GET: "AUDIT_STORE_GET",
	AUDIT_STORE_ID_GET: "AUDIT_STORE_ID_GET",
	AUDIT_STORE_ID_ACKNOWLEDGE: "AUDIT_STORE_ID_ACKNOWLEDGE",
	AUDIT_STORE_ID_SUBMIT: "AUDIT_STORE_ID_SUBMIT",
	AUDIT_STORE_ID_FAIL: "AUDIT_STORE_ID_FAIL",
	AUDIT_STORE_ID_WITDRAW: "AUDIT_STORE_ID_WITDRAW",
	AUDIT_STORE_UPDATED: "AUDIT_STORE_UPDATED",

	SECTION_GET: "SECTION_GET",

	ANSWER_GET: "ANSWER_GET",
	ANSWER_POST: "ANSWER_POST",

	REPORT_SUMMARY_POST: "REPORT_SUMMARY_POST",

	NPS_SECTION_POST: "NPS_SECTION_POST",

	REPORT_CONCERN_POST: "REPORT_CONCERN_POST",

	REPORT_SECTION_GET: "REPORT_SECTION_GET",
	REPORT_SECTION_COMMENT: "REPORT_SECTION_COMMENT",

	//Country get
	COUNTRY_GET: "COUNTRY_GET",
	//State get
	STATE_GET: "STATE_GET",
	//State get by country
	STATE_GET_BY_COUNTRY: "STATE_GET_BY_COUNTRY",
	//City get
	CITY_GET: "CITY_GET",
};

export default types;
